import httpClient from '../utils/httpClient';

export interface ChatMessage {
  id: string;
  conversation_id: string;
  sender_id: string;
  sender_name: string;
  // Backend may emit additional roles for partner-side or system messages.
  sender_role: 'user' | 'admin' | 'partner' | 'system';
  content: string;
  created_at: string;
  is_read: boolean;
}

export interface ChatConversation {
  id: string;
  user_id: string;
  subject?: string;
  category: string;
  // Backend statuses (see backend/api/routers/chat.py): open, in_progress,
  // waiting_on_customer, resolved, archived. The legacy 'active'/'closed'
  // values are kept for compatibility with older payloads.
  status: 'active' | 'archived' | 'closed' | 'open' | 'in_progress' | 'waiting_on_customer' | 'resolved';
  created_at: string;
  updated_at: string;
  unread_count: number;
}

const chatService = {
  async getActiveConversation(): Promise<ChatConversation | null> {
    return (await httpClient.get<ChatConversation | null>('/chat/conversations/active')).data;
  },

  async startConversation(data: {
    subject?: string;
    category: string;
    message: string;
  }): Promise<ChatConversation> {
    return (await httpClient.post<ChatConversation>('/chat/conversations', data)).data;
  },

  async getMessages(convId: string): Promise<ChatMessage[]> {
    return (await httpClient.get<ChatMessage[]>(`/chat/conversations/${convId}/messages`)).data;
  },

  async sendMessage(convId: string, content: string): Promise<ChatMessage> {
    return (await httpClient.post<ChatMessage>(`/chat/conversations/${convId}/send`, { content })).data;
  },

  async uploadImage(convId: string, file: File): Promise<ChatMessage> {
    const formData = new FormData();
    formData.append('file', file);
    return (await httpClient.post<ChatMessage>(`/chat/conversations/${convId}/upload`, formData)).data;
  },

  async rateConversation(convId: string, rating: number, comment?: string) {
    return (await httpClient.post(`/chat/conversations/${convId}/rate`, { rating, comment })).data;
  },
};

export default chatService;
